<template>
  <div class="container">
    <div class="no-data">
      <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
      <span>{{ tooltip }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: {
    tooltip: {
      type: String,
      default: "无数据",
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .no-data {
    width: 140px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -150px;
    img {
      width: 74px;
      height: 74px;
      object-fit: contain;
    }
    span {
      margin-top: 18px;
      font-size: 14px;
      color: #505667;
    }
  }
}
</style>